<template>
  <div
    class="grid grid-cols-2 border-dashed py-1 px-3"
    :class="[last ? 'border-transparent' : 'border-r-2']"
  >
    <div class="flex flex-col justify-between gap-2 relative">
      <div
        class="flex justify-center items-center w-7 min-w-7 h-7 rounded-md"
        :class="item.color"
      >
        <img
          :src="require(`../../../assets/icon/${item.icon}`)"
          alt="icon"
          loading="eager"
          class="w-4 h-auto"
        />
      </div>
      <h4
        class="text-gray-500 font-semibold text-wrap text-xs"
        v-html="item.title"
      ></h4>
      <img
        src="../../../assets/icon/arrow-dash.png"
        alt="arrow"
        class="w-[5px] h-auto absolute bottom-1 right-4"
      />
    </div>
    <div class="bg-slate-100 px-3 py-2 rounded-md">
      <v-tooltip :text="item.value" location="top">
        <template v-slot:activator="{ props }">
          <h3 class="text-lg font-semibold truncate" v-bind="props">
            {{ item.value }}
          </h3>
        </template>
      </v-tooltip>
      <h5 class="font-normal text-sm text-gray-500">{{ item.attribut }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardSummaryComponent",
  props: {
    item: Object,
    last: Boolean,
  },
};
</script>
